module.exports = __webpack_public_path__ + "static/media/mp.88b4c345.svg";